import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class PaymentService {
  static paymentDetails = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/payments/search",
        data: {
          keyword: "",
          status: "",
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let paymentDetail = response.data.data;

      return paymentDetail;
    } catch (err) {
      throw err;
    }
  };

  static paymentDetailsID = async (paymentID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/payments/" + paymentID,
        data: {
          filter: [],
          limit: 10,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let settingDetailID = response.data.data;

      return settingDetailID;
    } catch (err) {
      throw err;
    }
  };

  static settingDelete = async (settingID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/settings/delete/" + settingID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static settingUpdate = async (settingID, value) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/settings/update/" + settingID,
        data: {
          value: value,
        },

        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}
